'use client'

import { useEffect } from 'react'
import { useTranslations } from 'next-intl'
import useBreadcrumbStore, { BreadcrumbItem } from '@/store/breadcrumb'

type PropsType = {
  items: BreadcrumbItem[]
}

/**
 * Client component that sets breadcrumb items in the store.
 * This component can be used in server components to set breadcrumb items.
 * Always includes a dashboard item at the beginning.
 */
const BreadcrumbSetter = ({ items }: PropsType) => {
  const t = useTranslations()
  const { setItems, reset } = useBreadcrumbStore()

  useEffect(() => {
    const hasDashboard = items.length > 0 && items[0].href === '/' && items[0].label === t('dashboard')
    const itemsWithDashboard = hasDashboard ? items : [{ label: t('dashboard'), href: '/' }, ...items]

    setItems(itemsWithDashboard)

    return () => {
      reset()
    }
  }, [items, setItems, reset, t])

  return null
}

export default BreadcrumbSetter
